import React from 'react'
import Summery from '../components/sections/summery'
import Resume from '../components/sections/resume'
import Testimonials from '../components/sections/testimonials'

const About = () => {
    return (
        <>
            <Summery />
            <Resume />
            <Testimonials />
           
        </>
    )
}

export default About